// import { AutoAwesomeOutlined } from "@mui/icons-material";
import {
  Box,
  ButtonBase,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { motion } from "framer-motion";
import { defaultLocale } from "../config";
import useChatbot from "../provider/chatbot_provider";
import { toast } from "react-toastify";
type PromptItem = {
  id: string;
  label: string;
  prompt: string;
  key?: string;
};
const LegalPrompts: any = [
  {
    id: "1",
    label: "Formatted Judgement",
    // prompt: "Provide me a structured overview of the judgement",
    prompt: "FormattedJudgement",
  },
  {
    id: "2",
    label: "Summarize",
    // prompt: "Summarise the document highlighting the key points",
    prompt: "Summary",
  },
  {
    id: "3",
    label: "Translate",
    // prompt: "Translate complete document word-to-word in English",
    prompt: "Translate",
  },
];

const QCPrompts = [
  {
    id: "1",
    label: "Customer Info",
    // prompt: "Validate the customer information",
    prompt: "validateCustomerInfo",
  },
  {
    id: "2",
    label: "Validate T&C",
    // prompt: "Validate terms and conditions",
    prompt: "validateT&C",
  },
  {
    id: "3",
    label: "Commercial Quote",
    // prompt: "Perfrom end-to-end QC",
    prompt: "commercialQuoteQC",
  },
];

const WCClaimsPrompts = [
  {
    id: "1",
    label: "LOR Checklist",
    prompt: "LOR (List of Requirements) Checklist & Status",
    key: "lor_checklist",
  },
  // {
  //   id: "2",
  //   label: "Assessment Result",
  //   prompt: "File Assessment & Data Extraction",
  //   key: "assessment",
  // },
  // {
  //   id: "3",
  //   label: "Claim Note",
  //   prompt: "Claim Intimation Note (Policy & Loss Details)",
  //   key: "claim_intimation_note",
  // },
  {
    id: "4",
    label: "Claim Summary",
    prompt: "Claim Summary",
    key: "claim_summary",
  },
];

const TechEOPrompts = [
  {
    id: "1",
    label: "Tech E&O Summary",
    prompt: "Tech E&O Summary",
    key: "tech_eo_summary",
  },
];

const TechDOPrompts = [
  {
    id: "1",
    label: "Tech D&O Summary",
    prompt: "Tech D&O Summary",
    key: "tech_do_summary",
  },
];

const DTRPrompts = [
  {
    id: "1",
    label: "Executive Summary",
    prompt: "Executive Summary",
    key: "executive_summary",
  },
  {
    id: "2",
    label: "Detailed Summary",
    prompt: "Detailed Summary",
    key: "detailed_summary",
  },
  {
    id: "3",
    label: "Combined Summary",
    prompt: "Combined Summary",
    key: "combined_summary",
  },
];

const initialPrompts: Record<
  "legal" | "qc" | "wc-claims" | "tech-eo" | "tech-do" | "dtr",
  PromptItem[]
> = {
  legal: LegalPrompts,
  qc: QCPrompts,
  "wc-claims": WCClaimsPrompts,
  "tech-eo": TechEOPrompts,
  "tech-do": TechDOPrompts,
  dtr: DTRPrompts,
};

export default function DocumentAnalysisInitialPrompts({
  gridSpace = 3,
  align,
  vectorName,
  docChatType = "legal",
}: {
  gridSpace: number;
  align?: string;
  vectorName?: string;
  docChatType: keyof typeof initialPrompts;
}) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
  const { addConversation, isDocsProcessing } = useChatbot();

  return (
    <Grid
      container
      spacing={2}
      alignItems={align || "flex-start"}
      sx={{
        maxWidth: "45rem",
        margin: "0 auto",
        transform: isSmallScreen
          ? "translate(-7px,3.2rem)"
          : "translate(-7px,0)",
      }}
    >
      {initialPrompts[docChatType].map((initialPrompt, index) => (
        <Grid item md={gridSpace} key={index}>
          <motion.div
            initial={{ y: 100 }}
            transition={{ duration: 0.5 + index / 8 }}
            whileInView={{ y: 0 }}
            style={{ zIndex: -1 }}
          >
            <ButtonBase
              sx={{
                borderRadius: "0.625rem",
                textAlign: "left",
                border: "1px solid #d82a1b",
                color: "#d82a1b",
                width: "100%",
                overflow: "hidden",
              }}
              onClick={() => {
                if (isDocsProcessing) {
                  toast.info(
                    "Files received. Processing may take a few minutes...",
                    {
                      autoClose: 5000,
                    },
                  );
                  return;
                }
                addConversation(
                  initialPrompt.prompt,
                  defaultLocale,
                  vectorName,
                  ["wc-claims", "tech-eo", "tech-do", "dtr"].includes(
                    docChatType,
                  )
                    ? initialPrompt.key
                    : "prompt",
                );
              }}
            >
              <Box
                sx={{
                  p: 1.5,
                  "&:hover": {
                    // backgroundColor: theme.palette.action.hover,
                    backgroundColor: "#f44336",
                    color: "#fff",
                  },
                  width: "100%",
                }}
                bgcolor={"white"}
                display={"flex"}
                alignItems={"start"}
                gap={2}
              >
                {/* <Box sx={{ scale: "0.9" }}>
                  <AutoAwesomeOutlined />
                </Box> */}
                <Typography
                  variant="body2"
                  title={initialPrompt.label}
                  sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    display: "-webkit-box",
                    WebkitLineClamp: "2",
                    WebkitBoxOrient: "vertical",
                    fontSize: "0.75rem",
                    width: "100%",
                    textAlign: "center",
                  }}
                >
                  {initialPrompt.label}
                </Typography>
              </Box>
            </ButtonBase>
          </motion.div>
        </Grid>
      ))}
    </Grid>
  );
}
